/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React , { useEffect, useState } from "react";
import { MdKeyboardArrowRight, MdSearch } from "react-icons/md";
import { BiHomeAlt } from "react-icons/bi";
import "../LeaveReports/LeaveReports.css";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import Loader from "../../../Components/loader/loader";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Apiurl, GetToken } from "../../../Utils/utils";
import { toast } from "react-toastify";
import Select from "react-select";
import { FaDownload } from "react-icons/fa6";
import moment from "moment";


const EMPLeavesReports = () => {
  const [loading, setLoading] = useState(false);
  const LoginToken = GetToken();
  // const currentDate = new Date();
  // const firstDateOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  // const minDate = firstDateOfMonth.toISOString().split("T")[0];
  // currentDate.setDate(currentDate.getDate() - 45);
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(true);
  const [leaveRequestDuplicate, setLeaveRequestDuplicate] = useState([]);
  const [leaveRequest, setLeaveRequest] = useState();
  const [LeaveFilter,SetLeaveFilter]=useState('')
  const [leaveTypeData, setLeaveTypeData] = useState([]);

  const handleChangeLeaveFilter = (selectedOption) => {
    SetLeaveFilter(selectedOption);
  };
  const handleDataSearch = (e) => {
    const searchTerm = e?.target?.value?.toLowerCase();
    if (searchTerm) {
      const filteredData = leaveRequestDuplicate.filter(item =>
        item?.UserName?.toLowerCase()?.includes(searchTerm)
      );
      setLeaveRequest(filteredData);
    }
    else {
      setLeaveRequest(leaveRequestDuplicate);
    }
  };


  const GetLeavesData = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/GetLeaveTypes`,
    };
    axios(option)
      .then((response) => {
        setLoading(false);
        const data = JSON.parse(response?.data?.data);
        const modifiedData = data?.map((leave) => {
          if (leave.Name === "OD") {
            return { ...leave, Name: "Outdoor Leave" };
          } else {
            return leave;
          }
        });
        setLeaveTypeData(modifiedData);
        // setallLeavesList(modifiedData);
      })
      .catch((err) => {
        setLoading(false);
        // console.error("Error fetching leave types:", err);
      });
  };

  useEffect(()=>{
    GetLeavesData()
  },[])
 
  const HandelLeaveReport = () => {
    setLoading(true)
    const data = {
      data: JSON.stringify({
        LeaveType: LeaveFilter.Id ? LeaveFilter.Id : ''
      })
    };
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "Content-Type": "application/json", 
        "Authorization": `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/LeaveBalance`,
      data: JSON.stringify(data), 
    };
    axios(option)
      .then((response) => {
        setLoading(false)
        const data = JSON.parse(response?.data?.data);
        setLeaveRequest(data)
        setLeaveRequestDuplicate(data)
      })
      .catch((error) => {
        setLoading(false)
        if (
          error?.message === "Network Error" &&
          error?.code === "ERR_NETWORK"
        ) {
          toast.error("Your Session has been expired");
          navigate("/", { replace: true });;
        }
      });
  };
  useEffect(()=>{
    HandelLeaveReport()
  },[LeaveFilter])
  

  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />
        <>
        <div
            className={
              showSidebar
                ? "EMP-main-container-of-all-employees-sheet-hr"
                : "EMP-main-container-of-all-employees-page-new-sheet"
            }
          >
            <div className="EMP-report-all-icons">
              <div>
                <p className="MAIN-HEADING">
                Leave Report
                </p>
              </div>
              <div className="dashboiard-inner-header">
                <BiHomeAlt className="EMP-home-icon-header-inn" />
                <MdKeyboardArrowRight />
                <p> Report </p>
                <MdKeyboardArrowRight />
                <p>Leave Report</p>
              </div>
            </div>
            <div className="EMP-body-part-outer-container">
              <div className="EMP-inner-body-container-of-employee-table row-12">
                <div className=" first-side-in-body-header col 12">
                  <div className="EMP-employee-text-in-body">
                    {/* <h2>Leave Report</h2> */}
                  </div>
                  <div className="EMP-input-for-search-in-employee-body">
                    <MdSearch className="EMP-search-icon-in-input" />
                    <input
                      type="text"
                      placeholder="Search by Leave Types"  
                      onChange={(e) => handleDataSearch(e)}
                    />                   
                  </div>
                  <div className="Flex-container-of-leave-Report-filter">
                    <div>
                    <label htmlFor=""> Choose start date </label>
                    <input
                      type="date"
                      name=""
                      id=""
                      // value={searchAttendance?.startDate}
                      // onChange={(e) =>
                      //   setSearchAttendance({
                      //     ...searchAttendance,
                      //     startDate: e?.target?.value,
                      //   })
                      // }
                      // max={currentDate}
                    />
                    </div>
                    <div>
                    <label htmlFor=""> Choose End date </label>
                    <input
                      type="date"
                      name=""
                      id=""
                      // value={searchAttendance?.startDate}
                      // onChange={(e) =>
                      //   setSearchAttendance({
                      //     ...searchAttendance,
                      //     startDate: e?.target?.value,
                      //   })
                      // }
                      // max={currentDate}  
                    />
                    </div>
                    <div className="FaDownload-icon">
                    <FaDownload/>
                    </div>
                    </div>
                </div>
              </div>
              <div className="main-class-for-table-in-admin">
                <table className="table-of-employee-leaves table-of-admin-report">
                  <thead className="thead-of-emp-table-leaves">
                    <tr className="">
                      <th className="approve_Sr">Image</th>
                      <th className="approve_Date-report"> Name</th>
                      <th className="">
                        <p className="DAte-ofJoning-data">
                        Date of Joining
                        </p>
                        </th>
                      <th className="approve_From">Department</th>
                      <th className="approve_To">Leave Type</th>
                      <th className="approve_Reason-report-two">Total Leaves</th>
                      <th className="approve_Reason-report-three">Total Leave Taken</th>
                      <th className="approve_Reason-report-one">Remaining Leaves</th>
                      <th className="approve_Reason-report-four">Carry Over</th>
                    </tr>
                  </thead>

                  <tbody className="tbody-ofemp-table-leaves">
                      <>
                      {leaveRequest?.sort((a, b) => a?.UserName?.localeCompare(b?.UserName))?.map((leaveRecord, index) => {
    const Date = moment(leaveRecord?.DateofJoining).format("DD MMM YYYY");
    const TotalLeaves = leaveRecord.CasualLeave + leaveRecord.SickLeave;
    const TotalLeavesTaken = leaveRecord.CasualLeavesTaken + leaveRecord.SickLeavesTaken;

    return (
      <tr key={index}>
        <td className="one-image">
          <img src={leaveRecord?.imageurl} alt="" />
        </td>
        <td>{leaveRecord?.UserName}</td>
        <td>{Date}</td>
        <td>{leaveRecord?.Department}</td>
        <td>
          <Select
            classNamePrefix="Leave-typedata"
            placeholder="Leave Type"
            value={LeaveFilter}
            onChange={handleChangeLeaveFilter}
            options={leaveTypeData}
            getOptionLabel={(option) => option.Name}
            getOptionValue={(option) => option.Id}
          />
        </td>
        <td>{TotalLeaves}</td>
        <td>{TotalLeavesTaken}</td>
        <td>{leaveRecord?.RemainingCasualLeaves + leaveRecord?.RemainingSickLeaves}</td>
        <td>{leaveRecord?.SLDCarryOver}</td>
      </tr>
    );
  })}

                         
                      </>
                    
                  </tbody>

              
                </table>
                <div></div>
              </div>
            </div>
          </div>
        </>
      </div>
    </>
  );
};
export default EMPLeavesReports;